exports = module.exports = require("../../../../../../../web-ai-translation/node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../../web-ai-translation/node_modules/css-loader/index.js??ref--8-oneOf-1-1!../../../../../../../web-ai-translation/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../../web-ai-translation/node_modules/postcss-loader/src/index.js??ref--8-oneOf-1-2!bootstrap/dist/css/bootstrap.css"), "");

// module
exports.push([module.id, ".sidebar-nav .nav>li:not(.nav-divider)+.nav-title-group{margin-top:20px}.sidebar-nav .nav>.nav-title-group:first-child{margin-top:0!important}", ""]);

// exports
